export default "__VITE_ASSET__BboEoWzP__"